import React, { useState } from "react";
import "./Header.css";
import { ColorArray } from "../config/ColorArray";

// IMPORT REACT ICONS
import {
    BsHouseDoor,
    BsPersonCircle,
    BsGear,
    BsShieldCheck,
    BsDatabaseFillExclamation,
    BsNewspaper,
    BsEnvelope
} from "react-icons/bs";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const getNavStyle = (index) => {
        const colors = ColorArray[index % ColorArray.length];
        return {
            background: `linear-gradient(135deg, ${colors.color1} 0%, ${colors.color2} 100%)`,
        };
    };

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <header className="header-wrapper">
            <nav>
                <button
                    className={`hamburger ${isOpen ? "active" : ""}`}
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                >
                    <span className="hamburger-bar"></span>
                    <span className="hamburger-bar"></span>
                    <span className="hamburger-bar"></span>
                </button>

                <ul className={`navbar ${isOpen ? "show" : ""}`} id="navMenu">
                    <li className="nav-item">
                        <a href="/" className="nav-link" style={getNavStyle(0)}>
                            <BsHouseDoor size={20} /> હોમ
                        </a>
                    </li>

                    <li className="nav-item">
                        <a href="#" className="nav-link" style={getNavStyle(1)}>
                            <BsPersonCircle size={20} /> અબાઉટ  અસ 
                        </a>
                    </li>

                    {/* <li className="nav-item">
                        <a href="#" className="nav-link" style={getNavStyle(2)}>
                            <BsGear size={20} /> સર્વિસ
                        </a>
                    </li> */}

                    <li className="nav-item">
                        <a href="#" className="nav-link" style={getNavStyle(3)}>
                            <BsShieldCheck size={20} />પ્રાઇવસી પોલિસી
                        </a>
                    </li>

                    <li className="nav-item">
                        <a href="#" className="nav-link" style={getNavStyle(4)}>
                            <BsDatabaseFillExclamation size={20} /> ડિસક્લેમર
                        </a>
                    </li>

                    {/* <li className="nav-item">
                        <a href="#" className="nav-link" style={getNavStyle(5)}>
                            <BsNewspaper size={20} /> ન્યૂઝ
                        </a>
                    </li> */}   

                    <li className="nav-item">
                        <a href="#" className="nav-link" style={getNavStyle(6)}>
                            <BsEnvelope size={20} /> કોન્ટાક્ટ અસ
                        </a>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Navbar;
